import { createSelector } from 'reselect';

import { selectActiveCartItems } from './selectActiveCartItems';

export const selectSelectedCartItems = createSelector(
    [selectActiveCartItems],
    (items) => items.filter(item => item.isSelected),
);
